<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>
                <v-row class="pa-4">
                    <h3>Add complaint event</h3>
                </v-row>
                <v-row class="mb-6"><v-divider></v-divider></v-row>

                <v-row dense class="pl-4 mt-8">
                    <v-col cols="4">
                        <select_status :selected_eventstatus="hkrg_klst" label="Status" field="hkrg_klst" @updateData="updateData" />
                    </v-col>
                </v-row>

                <v-row dense class="pl-4 pr-6">
                    <v-col cols=12>
                        <v-form v-model="hkrg_valid">
                            <v-textarea v-model="hkrg_text" rows="4" required label="Complaint event text" :rules="descriptionRules">{{ hkrg_text }}</v-textarea>
                        </v-form>
                    </v-col>
                </v-row>

                <v-card fluid flat class="mt-0 pl-4 mb-4 pr-6">
                    <hokl_hosm_links :links="links" @updateData="updateData" />
                </v-card>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" small :disabled="!hkrg_valid" v-on:click="addHkrg()">Save</v-btn>
                    <v-btn color="primary" small v-on:click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>

import select_status from '@/components/huov/hokl/ui/select_eventstatus.vue';
import hokl_hosm_links from '@/components/huov/ui/hokl_hosm_links.vue';

export default {
    components: {
        select_status,
        hokl_hosm_links,
    },
    data() {
        return {
            dialog: false,
            hkrg_valid: false,
            hkrg_text: '',
            encrid: '',
            hkrg_klst: '',
            links: [],
            descriptionRules: [
                v => !!v || "A description / value is required"
            ]
        }
    },

    methods: {
        open(encrid) {
            this.dialog = true;
            this.encrid = encrid;
            this.hkrg_text = '';
            this.hkrg_klst = 'new';
            this.links = [];
        },
        updateData(data) {
            console.log('updateData', data);
            this[data.field] = data.value;
        },
        addHkrg() {
            this.$axios
                .post("ares/json/ares/huov/hokl/addHkrg.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHkrg"
                    },
                    addHkrg: {
                        hokl_encrid: this.encrid,
                        hkrg_text: this.hkrg_text,
                        hkrg_klst: this.hkrg_klst,
                        links: this.links,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$emit('updateData', 'refresh');
                        this.dialog = false; // close dialog + update
                    }
                });
        }

    }
}
</script>

<style scoped></style>